<template>
  <div class="scott-input">
    <div class="form-group row">
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <div class="toolbar text-right mb-3">
          <button v-if="value.length" type="button" class="mt-1 btn btn-secondary" @click="toggleAll()">
            <i class="fa" :class="expandAccordians ? 'fa-chevron-up' : 'fa-chevron-down'"></i> All
          </button>
        </div>
        <div v-for="(val, index) in value" :key="index">
          <div class="card mb-3">
            <accordian-display
            ref="accordians"
            :defaultOpen="true"
            :title="val.textOnly ? val.description : 'Item ' + parseInt(index + 1)"
            :icon="val.textOnly ? 'fa fa-fw fa-heading' : 'fa fa-fw fa-table'">
              <div class="card-body text-dark">
                <div class="row mb-2">
                  <div class="col">
                    <label class="custom-control material-checkbox">
                      <input
                        type="checkbox"
                        class="material-control-input"
                        :value="val.includeInScottSchedule"
                        :checked="val.includeInScottSchedule"
                        @change="includeChecked($event, index)">
                      <span class="material-control-indicator"></span>
                      <span class="material-control-description">
                        <strong>Include in Scott Schedule</strong>
                      </span>
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 my-1 text-center">
                    <div class="scott-textarea" @click="openTextEditor(val, index)" v-html="val.description">
                      ?
                    </div>
                    <div class="row clearfix">
                      <div class="col-6 col-sm-4 col-md-3" v-for="image in val.images" :key="image.uuid">
                        <img class="img-fluid mb-3" :src="'https://roscon.s3.amazonaws.com/' + image.objectKey" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 my-1">
                    <currency-input
                    v-model="val.ownersCost"
                    :options="{
                      label: 'Owner\'s Cost To Rectify',
                      name: 'ownersCost',
                      value: val.ownersCost,
                      fullWidth: true
                    }">
                  </currency-input>
                  <rich-text-input
                    ref="finding"
                    v-model="val.ownersCostNotes"
                    :options="{
                      label: 'Owner\'s Cost To Rectify (Notes)',
                      name: 'ownersCostNotes',
                      value: val.ownersCostNotes,
                      height: 250,
                      index: val.added,
                      fullWidth: true
                    }">
                  </rich-text-input>
                  </div>
                </div>
              </div>
            </accordian-display>
          </div>
        </div>
        <div v-if="value.length" class="toolbar text-right">
          <button type="button" class="mt-1 btn btn-secondary" @click="toggleAll()">
            <i class="fa fa-chevron-up"></i> All
          </button>
        </div>
      </div>
    </div>
    <modal
      v-if="editingText"
      :title="'Edit Description'"
      :is-open="editingText"
      @dismiss="closeModal()">
      <rich-text-input :options="editorOpts" v-model="editorOpts.value">
      </rich-text-input>
      <div slot="footer">
        <button type="button" class="btn btn-success" @click="closeModal()">
          Done
        </button>
      </div>
    </modal>
    <div class="modal-backdrop fade show" v-show="editingText"></div>
  </div>
</template>

<script>
  import AccordianDisplay from '@/components/displays/AccordianDisplay'
  import { OPEN_MODAL, CLOSE_MODAL, COMPONENT_METHOD } from '@/vuex/types'
  import Modal from '@/components/ui/Modal'
  import RichTextInput from '@/components/inputs/RichTextInput'
  import CurrencyInput from '@/components/inputs/CurrencyInput'
  import TextInput from '@/components/inputs/TextInput'
  import {
    validationClass,
    validationIcon,
    validationMessage
  } from '@/util/helpers'

  export default {
    name: 'ScottInput',
    props: {
      value: {
        type: Array
      },
      options: {
        type: Object,
        default () {
          return {
            valid: false,
            dirty: false
          }
        }
      }
    },
    components: {
      AccordianDisplay,
      CurrencyInput,
      Modal,
      RichTextInput,
      TextInput
    },
    data () {
      return {
        expandAccordians: true,
        editorOpts: {},
        editingText: false,
        isDirty: false,
        isValid: false
      }
    },
    computed: {
      validationClass,
      validationIcon,
      validationMessage
    },
    mounted () {
      this.validate(this.value)
    },
    methods: {
      includeChecked (val, index) {
        let values = this.value
        values[index].includeInScottSchedule = !values[index].includeInScottSchedule
        this.$emit('input', values)
      },
      toggleAll () {
        let method = 'close'
        if (!this.expandAccordians) method = 'open'
        this.$store.dispatch(COMPONENT_METHOD, { method, payload: this.$refs.accordians })
        this.expandAccordians = !this.expandAccordians
      },
      validate (val = this.value) {
        if (this.$refs.uploaders) {
          for (let upl of this.$refs.uploaders) {
            upl.valArray = upl.value
          }
        }
        this.$emit('input', val)
        this.isDirty = true
        if (Array.isArray(val) && val.length) {
          this.isValid = true
        } else if (this.options.required) {
          this.isValid = false
        } else {
          this.isValid = true
        }
      },
      openTextEditor (val, index) {
        this.editorOpts = {
          index,
          name: 'textEditor',
          fullWidth: true,
          value: val.description
        }
        this.editingText = true
        this.$store.dispatch(OPEN_MODAL, {
          title: 'Edit Description',
          alreadyOpen: true
        })
      },
      async closeModal () {
        tinymce.triggerSave()
        let newDescription = tinymce.activeEditor.getContent({format: 'raw'})
        await this.$nextTick()
        let values = this.value
        values[this.editorOpts.index].description = newDescription
        this.$emit('input', values)
        this.editingText = false
        this.$store.commit(CLOSE_MODAL, 0)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/ScottInput.vue